/** Remove reset credentials from the query string (history + referrers). */
export function stripResetCredentialsFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("uid") && !params.has("token")) {
    return;
  }

  params.delete("uid");
  params.delete("token");
  const remainder = params.toString();
  const nextUrl =
    window.location.pathname +
    (remainder ? `?${remainder}` : "") +
    window.location.hash;
  window.history.replaceState(null, "", nextUrl);
}
